import { Country } from '@dreryk/address-common-api';

import { useFormController } from '@dreryk/react-common';

import {
   MedicalDataAccessAuthorizationFormBean,
   MedicalDataAccessAuthorizationFormController,
} from './MedicalDataAccessAuthorizationModalForm.types';

const useMedicalDataAccessAuthorizationFormController = (
   initialValues: MedicalDataAccessAuthorizationFormBean | null
): MedicalDataAccessAuthorizationFormController => {
   return useFormController(
      initialValues ?? {
         firstName: null,
         middleName: null,
         lastName: null,
         authorizedPersonIdentifierType: 'BirthDate',
         authorizedPersonIdentifierValue: null,
         nationalIdentificationNumberCountry: null,
         passportCountry: null,
         passportValidTo: null,
         birthDate: null,
         country: Country.DEFAULT,
         town: null,
         postcode: null,
         street: null,
         house: null,
         flat: null,
         phoneNumber: null,
         informationAccess: false,
         documentationAccess: false,
      }
   );
};

export { useMedicalDataAccessAuthorizationFormController };
